import { render, staticRenderFns } from "./CharacteristicColumn.vue?vue&type=template&id=c96c0c7a&"
import script from "./CharacteristicColumn.vue?vue&type=script&lang=js&"
export * from "./CharacteristicColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports